/****************************************************
 * Module Name:  ExportToExcel.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/
import { Download } from "@mui/icons-material";
import { Button } from "@mui/material";
import React, { Component } from "react";
import ReactExport from 'react-data-export';

const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;

export default class ExportToExcel extends Component {

    constructor(props) {
        super(props);

        this.state = {

        };
    }

    render() {
        return (
            <div>
                <ExcelFile element={
                    <Button
                        component="label"
                        variant="outlined"
                        size="small"
                        color="secondary"
                        sx={{ ml: "5px" }}
                        startIcon={<Download size="large" />}
                    >
                        Excel
                    </Button>}>
                    <ExcelSheet dataSet={this.props.sourceData} name="Sheet 1" />
                </ExcelFile>
            </div>
        );
    }
}